import { Pipe, PipeTransform } from '@angular/core';
import { FilterableTraceSource, Trace, isInboundTraceSource } from '../models/tracer.model';

@Pipe({
  name: 'getTracesBySource',
})
export class GetTracesBySourcePipe implements PipeTransform {
  transform(
    traces: Trace[],
    uniqueTracesByProviders: Trace[],
    shouldTracesBeGrouped: boolean,
    source: FilterableTraceSource,
  ): Trace[] {
    // The "json-api" pipe argument also accepts source="sidecar" rows —
    // the sidecar produces the same inbound traces the legacy in-process
    // tracer used to write under "json-api".
    const matches = (s: string) => (source === 'json-api' ? isInboundTraceSource(s) : s === source);

    if (shouldTracesBeGrouped) {
      return uniqueTracesByProviders?.filter((item) => matches(item.Source));
    }
    const filtered = traces?.filter((item) => matches(item.Source));
    return source === 'requester' ? groupByProvider(filtered) : filtered;
  }
}

/**
 * Orders airline legs so each provider's calls sit together: providers in the
 * order they were first called, and within one provider the calls in the order
 * made (so a Login comes right before the call it was for). The API returns
 * legs in call order, which interleaves a fan-out's airlines — AER, EY, U2,
 * AER, … — and puts a provider's login far from its request.
 */
export function groupByProvider(traces: Trace[] | undefined): Trace[] {
  if (!traces) {
    return [];
  }
  const first = new Map<string, number>();
  traces.forEach((t, i) => {
    if (!first.has(t.Providers)) {
      first.set(t.Providers, i);
    }
  });
  return traces
    .map((t, i) => ({ t, i }))
    .sort((a, b) => first.get(a.t.Providers)! - first.get(b.t.Providers)! || a.i - b.i)
    .map(({ t }) => t);
}
